export default __webpack_public_path__ + "static/media/rooftopterrace.83366244.svg";